// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customText[data-v-ee9371d6] {\n  color: rgba(0, 0, 0, 0.8);\n  text-align: left;\n  max-width: 176px;\n  font-weight: 400;\n}\n.customTop[data-v-ee9371d6] {\n  top: 2px;\n}", ""]);
// Exports
module.exports = exports;
